import Button from '@vromo/ui/components/Button';
import Container from '@vromo/ui/components/Container';
import Input from '@vromo/ui/components/Input';
import { css } from 'emotion';
import React, { memo } from 'react';
import Errors from '../Errors';
import { useTranslation } from 'react-i18next';

const MemoInput = memo(Input);

const formGroup = css`
    margin-bottom: 15px;
`;

const ChangePassword = ({
    errors,
    oldPassword,
    onChangeOldPassword,
    newPassword,
    onChangeNewPassword,
    confirmPassword,
    onChangeConfirmPassword,
    updatePassword,
    isSavingPassword
}: any) => {
    const { t } = useTranslation();
    const translate = (key: string, params?: any) => t(`settings.${key}`, params);

    return (
        <Container title={translate('changePassword')}>
            <div>
                <Errors errors={errors} field="password" />
                <div className={formGroup}>
                    <MemoInput
                        type="password"
                        label={translate('oldPassword')}
                        value={oldPassword}
                        onChange={onChangeOldPassword}
                    />
                </div>
                <div className={formGroup}>
                    <MemoInput
                        type="password"
                        label={translate('newPassword')}
                        value={newPassword}
                        onChange={onChangeNewPassword}
                    />
                </div>
                <div className={formGroup}>
                    <MemoInput
                        type="password"
                        label={translate('confirmPassword')}
                        value={confirmPassword}
                        onChange={onChangeConfirmPassword}
                    />
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        type="submit"
                        onClick={updatePassword}
                        disabled={isSavingPassword}
                        loading={isSavingPassword}>
                        {translate('save')}
                    </Button>
                </div>
            </div>
        </Container>
    );
};

export default memo(ChangePassword);
